<header class="mobile dbControl">
    DB CONTROL
</header>
<main class="mobile dbControl">
    <div *ngIf="!dbAccessAllowed" style="padding: 0.5em;">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <mat-card-content>
                <mat-form-field>
                    <input matInput placeholder="Passwort" type="password" formControlName="dbPW" required>
                </mat-form-field>
            </mat-card-content>
            <button mat-stroked-button i18n>Ok</button>
        </form>
    </div>

    <div *ngIf="dbAccessAllowed" style="padding: 0.5em;">

        <form [formGroup]="formDB" (ngSubmit)="onDBSubmit()">
            <mat-card-content>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Datenbank" formControlName="dbDatabase" required>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Speicher</mat-label>
                        <mat-select formControlName="dbStorrage">
                            <mat-option *ngFor="let store of storrages" [value]="store.key">
                                {{store.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Schlüssel" formControlName="dbKey" required>
                    </mat-form-field>
                    <mat-checkbox [checked]="isArray">Schlüssel ist ein Array</mat-checkbox>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Unique DBField(s)" formControlName="dbUniqueField">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="ID Field Value(s)" formControlName="dbUniqueIDValue">
                    </mat-form-field>
                    <button mat-stroked-button i18n>Datensatz löschen</button>
                </div>
            </mat-card-content>
        </form>

    </div>
</main>

<footer class="mobile dbControl" *ngIf="dbControlOnMobile">
    <mat-icon class="icon-size" (click)="goBack()">
        arrow_back
    </mat-icon>
</footer>
